import { all } from 'redux-saga/effects';

import inviteSagas from './invite';
import listSagas from './list';
import userSagas from './user';

export default function* rootSaga() {
  yield all([inviteSagas(), userSagas(), listSagas()]);
}
